export default __webpack_public_path__ + "static/media/Group60.d63bf9fd.png";